import { ApReportStatus } from 'ap-openapi';

export const isEditableReportStatus = (status: ApReportStatus | undefined) => {
  if (status === undefined) {
    return false;
  }
  const editableStatuses: ApReportStatus[] = [
    ApReportStatus.unsubmitted,
    ApReportStatus.rejected,
    ApReportStatus.canceled,
  ];
  return editableStatuses.includes(status);
};
